<ng-template #supportModal cdkPortalOutlet></ng-template>

<qai-app-header *ngIf="!hideNavbar">
    <a qai-app-nav qaiSlot="logo" [href]="'/'" [routerLink]="'/'">
        <qai-app-logo />
    </a>

    <qai-app-nav-list qaiSlot="nav" [items]="formattedLinks" />

    <button qai-app-nav *ngIf="isQcAdmin" (click)="goToAdminPortal()" [condenseAt]="580" qaiSlot="admin">
        <qai-icon kind="web" qaiSlot="start" />
        {{'ADMIN' | transloco}}
        <qai-icon kind="link-external" qaiSlot="end" />
    </button>

    <button qai-app-nav qaiSlot="help" (click)="openModal()" [condenseAt]="580" [iconOnly]="isQcAdmin">
        <qai-icon kind="help-circle" qaiSlot="start" />
        {{'SUPPORT_SMALL' | transloco}}
    </button>

    <button qai-app-nav [condenseAt]="580" #userMenuRef qaiSlot="user">
        <qai-app-nav-user [fullName]="userFirstName ? userFirstName : ('USER' | transloco)" qaiSlot="start" />
        <qai-icon kind="chevron-down" qaiSlot="end" />
    </button>

    <qai-menu qaiSlot="user" [qaiFloating]="userMenuRef.elementRef.nativeElement" [placement]="'below-end'"
        [events]="['click']" [offset]="4" class="theme-light">
        <qai-menusection>
            <qai-user-info [fullName]="userFirstName ? userFirstName + ' ' + userLastName: ('USER' | transloco)" email="" />
        </qai-menusection>
        <qai-menusection>
            <button qai-menuitem [label]="'LOGOUT' | transloco" (mousedown)="logout($event)" (touchstart)="logout($event)">
                <qai-icon kind="log-out" positionStart />
            </button>
        </qai-menusection>
    </qai-menu>
</qai-app-header>
